module.exports = __webpack_public_path__ + "1_0_65/img/share.d32a33d7.svg";